import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    let title = "No Brokerage Paying Guest";

    switch (true) {
      case path === "/":
        title = "Top No Brokerage Girls PG in Malad, Goregoan and Kandivali Mumbai | Safe & Fully Furnished";
        break;

      case path === "/about":
        title = "About Us | No Brokerage Girls PG in Malad, Goregoan and Kandivali Mumbai";
        break;

      case path === "/gallery":
        title = "Gallery | No Brokerage Paying Guest Malad, Goregoan and Kandivali Mumbai";
        break;

      case path === "/faq":
        title = "FAQs | Girls PG in Malad, Goregoan and Kandivali Mumbai";
        break;

      case path === "/SaffronHabitat":
        title = "Saffron Habitat | Premium Girls PG in Malad, Goregoan and Kandivali";
        break;

      case path === "/blog":
        title = "Girls PG Blogs | No Brokerage Paying Guest Malad, Goregoan and Kandivali";
        break;

      case path.startsWith("/blog/"):
        title = "Blog | No Brokerage Girls PG in Malad, Goregoan and Kandivali Mumbai";
        break;

      case path === "/contact":
        title = "Contact Us | No Brokerage Girls PG Malad, Goregoan and Kandivali";
        break;

      default:
        title = "No Brokerage Girls PG in Malad, Goregoan and Kandivali Mumbai";
    }

    document.title = title;
  }, [location]);

  return null;
};

export default PageTitle;
